<template>
    <div class="GroupSearch">
        <Row :gutter="4">
            <Col span="4">
                <!-- v-on:input实时查询 -->
                <Input search v-model="groupSearchKey" :placeholder="$t('permission_configuration_management.group.checkByGroupName')" @on-search="searchGroup()"/>
            </Col>
            <!-- 选择公司 -->
            <div v-if="company==1">
              <Col span="4">
                  <Select v-model="companyId" filterable :placeholder="$t('permission_configuration_management.common.pleaseSelectCompany')" :transfer="true" @on-change="searchCompany">
                      <Option value=" " selected>{{$t('alarms.common.all')}}</Option>
                      <Option :value="item.id" v-for="item in companyList" :key="item.id">{{item.name}}</Option>
                  </Select>
              </Col>
            </div>
            <Col span="2">
                <add-groups></add-groups>
            </Col>
        </Row>
    </div>
</template>
<script>
    import {setCookie,getCookie} from '../../../../utils/cookieUtil.js'
    import AddGroups from '../group/AddGroups'
    import TableGroups from '../group/TableGroups'
    var tableGroups = TableGroups;
    export default {
        name: 'GroupSearch',
        components: {
            AddGroups
        },
        data () {
            return {
                company: getCookie(global.companyId),
                companyId: '',
                companyList: [],
                groupSearchKey:'',
                groupSearchName:''
            }
        },
        mounted: function(){
            if (this.company == 1) {
                this.getCompanyDropDownBox();
            }
        },
        methods: {
            // 获取公司下拉框
            getCompanyDropDownBox: function(){
               this.$api.company.getCompanyDropDownBox("userName",getCookie(global.cookieName))
                 .then(res => {
                     this.companyList = res.data;
                 });
             },
            // 按公司搜索
            searchCompany: function(){
                // 在需要传递参数的组件中，定义一个emit发送需要传递的值，键名可以自己定义（可以为对象）
                eventBus.$emit('companyId', this.companyId);
                tableGroups.methods.showAll();
            },
            searchGroup: function(){
                // 在需要传递参数的组件中，定义一个emit发送需要传递的值，键名可以自己定义（可以为对象）
                eventBus.$emit('groupSearchName', this.groupSearchKey);
                tableGroups.methods.showAll();
            }
        }
    }
</script>
<style scoped>
    .GroupSearch
    {
        padding: 4px 0px 15px 0px;
    }
</style>



// WEBPACK FOOTER //
// src/components/configuration/permissions_configuration_management/group/GroupSearch.vue